export const IGNORE_CLASS = 'ignore-click-outside';
export const DROPDOWN_CLASS = 'rss-dropdown';
export const SELECT_CLASS = 'smart-select';
export const OPTION_CLASS = 'rss-option';
export const LABEL_CLASS = 'rss-label';
export const MOBILE_BREAKPOINT = 375;
